import React, {
  useEffect, useState, useRef, ChangeEvent, MouseEvent,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button, Popover, Popper } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, debounce, trim } from 'lodash';
import posthog from 'posthog-js';
import URI from 'urijs';

import './scss/index.scss';
import './scss/login.scss';
import Color from '@tool/color';
import LoginSlick from './component/login-slick';
import LoginComp from './component/login-comp';
import { HotIcon } from '@styled/icon';
import {
  DButton, SmallButton, LoginButton, EButton,
  DInput, DCheckbox, LButton, FButton,
} from './styled';
import moRegister, {
  changeCompany, changeEmail, changePhone, changeCaptcha,
  changePassword, changeNickname, changeInviteCode,
  getCaptcha, onRegister, togglePop, reset, chooseCompany,
} from '@store/register';
import AppLoading from '@con/app-loading';
import moSkin from '@store/skin';
import Service from '@service/index';
import HomeService from '@service/home';
import { NONAME } from 'dns';
import { buildAuthPagePath } from '@lib/registration-attribution';

interface IProps {}
interface IState {}

const EInput = styled(DInput)(() => ({
  width: '170px',
}));

const GButton = styled(EButton)(() => ({
  '&.text-15': {
    cursor: 'default',
    backgroundColor: Color.c999,
  },
}));

const CButton = styled(Button)(() => ({
  justifyContent: 'flex-start',
  height: '40px',
  fontSize: '14px',
  fontWeight: 500,
  color: Color.c000,
}));

const Register = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    company, email, phone, captcha, password, nickname, inviteCode,
    companyEmpty, emailEmpty, phoneEmpty, captchaEmpty, passwordEmpty,
    qrText, qrClass, phoneErrorText, emailErrorText, companyList, isPop,
  } = moRegister;
  const { mainColor, partner } = moSkin;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const companyRef = useRef(null);
  const [userCount, setUserCount] = useState<number | string>('');

  const getUserCount = async () => {
    const res: any = await HomeService.getData();
    setUserCount(res?.userCount || '-');
  };

  useEffect(() => {
    document.title = '注册';
    posthog.capture('访问注册人数', {});

    const uri = new URI(window.location.href);
    const activityUUid = uri.query(true).activity_uuid;
    sessionStorage.setItem('activity_uuid', activityUUid);
    console.log('activity_uuid -- ', activityUUid);
    if (activityUUid) Service.postActivity(activityUUid);

    getUserCount();

    reset();
    // @ts-ignore
    if (companyRef.current) setAnchorEl(companyRef.current);

    return () => {};
  }, [companyRef]);

  // 跳转至登录页面
  const onLogin = () => {
    posthog.capture('注册-立即登录按钮', {});
    navi(buildAuthPagePath('/login', window.location.search));
  };

  // 忘记密码
  const onForget = () => {
    posthog.capture('注册-忘记密码按钮', {});
    navi(buildAuthPagePath('/forget', window.location.search));
  };

  // 联系客服
  const onContact = () => {
    posthog.capture('注册-联系客服按钮', {});
    const $btn = document.getElementById('nb_invite_ok');
    if ($btn) $btn.click();
  };

  // 注册
  const clickRegister = () => {
    posthog.capture('点击注册人数', {});
    onRegister(() => { navi(buildAuthPagePath('/register-setting', window.location.search)); });
  };

  // 输入所在公司
  const onChange = async (ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    togglePop(true);
    changeCompany(ev.target.value);
  };

  const onFocus = () => {
    // console.log('value -- ', company);
    // console.log('companyList -- ', toJS(companyList));
    // if (trim(company) && !isEmpty(companyList))
    togglePop(true);
  };

  const onCompany = (item: any) => {
    chooseCompany(item);
    togglePop(false);
  };

  const onNothing = (ev: MouseEvent) => {
    ev.stopPropagation();
  };

  const clickPage = (ev: MouseEvent) => {
    ev.stopPropagation();
    togglePop(false);
  };

  const onTitle = (ev: MouseEvent) => {
    ev.stopPropagation();
    togglePop(false);
  };

  return (
    <section aria-hidden="true" className="page-1101" onClick={clickPage}>
      <LoginSlick />
      <LoginComp isAgreement={true}>
        <section aria-hidden="true" className="login-155" onClick={onNothing}>
          <section className="line-001">
            <HotIcon color="#6980FF" width={18} height={18} />
            <span style={{ marginLeft: '3px' }}>已有</span>
            <b className="mont-font">{userCount}</b>
            <span>家企业注册</span>
          </section>
          <section aria-hidden="true" className="line-010" onClick={onTitle}>
            <strong>注册新账号</strong>
            <i>(送会员权益)</i>
            <p>
              <span>已有{partner === 'smartsalary' ? '薪智' : ''}账号？</span>
              <FButton onClick={onLogin} style={{ color: mainColor }}>立即登录</FButton>
            </p>
          </section>
          <section className="line-012">
            <section className="line-115 line-116">
              <DInput ref={companyRef} value={company} onChange={onChange}
                onFocus={onFocus} placeholder="所在公司" />
              <span className={[
                'err-11', companyEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>所在公司不能为空
              </span>
              {!isEmpty(companyList) ? (
                <Popper open={isPop} anchorEl={anchorEl}>
                  <section className="company-pop_111">
                    {companyList.map((item: any, index: number) => (
                      <CButton key={index} onClick={() => onCompany(item)}>{item.company}
                      </CButton>
                    ))}
                  </section>
                </Popper>
              ) : null}
            </section>

            <section className="line-115 line-117">
              <DInput value={email} onChange={changeEmail}
                placeholder="注册邮箱" />
              <span className={[
                'err-11', emailEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>{emailErrorText}
              </span>
            </section>
            <section className="line-115 line-117">
              <DInput value={phone} onChange={changePhone}
                placeholder="手机号码" />
              <span className={[
                'err-11', phoneEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>{phoneErrorText}
              </span>
            </section>
            <section className="line-0011" style={{ display: 'none' }}>
              <section className="line-115 line-117">
                <DInput value={captcha} onChange={changeCaptcha} placeholder="短信验证码"/>
                <GButton onClick={getCaptcha}
                  className={[qrClass ? 'text-15' : ''].join(' ')}
                  style={{ backgroundColor: qrText === '获取验证码' ? mainColor : Color.c999 }}>{qrText}
                </GButton>
                <span className={[
                  'err-11', captchaEmpty ? 'err-visible' : 'err-hidden',
                ].join(' ')}>验证码不能为空
                </span>
              </section>
            </section>
          </section>
          <section className="line-015">
            <p className="line-0151"><i /><span>以下非必填项</span><i /></p>
            {/* 邀请码：沉底，标记可选 */}
            <section className="line-0152">
              <DInput value={inviteCode} onChange={changeInviteCode}
                placeholder="邀请码（可选）" />
            </section>
          </section>
          <LoginButton onClick={clickRegister}
            style={{ backgroundColor: mainColor }}>注册
          </LoginButton>
          <p className="line-016">
            <LButton onClick={onForget}>忘记密码</LButton>
            {partner === 'smartsalary' ? (
              <><b>|</b><LButton onClick={onContact}>联系客服</LButton></>
            ) : null}
          </p>
        </section>
      </LoginComp>
      <AppLoading />
    </section>
  );
};

export default observer(Register);
